export const defaultParameters = {
  aizawa: {
    name: "aizawa",
    x: 0.5,
    y: 1.0,
    z: 0.01,
    dt: 0.01,
    a: 0.95,
    b: 0.7,
    c: 0.6,
    d: 3.5,
    e: 0.25,
    f: 0.1,
  },
  arneodo: {
    name: "arneodo",
    x: 0.5,
    y: 0.38,
    z: 0.4,
    dt: 0.0065,
    a: -5.5,
    b: 3.5,
    c: -1,
  },
  chen: {
    name: "chen",
    x: 5,
    y: 10,
    z: 12,
    dt: 0.0038,
    a: 5,
    b: -10,
    c: -0.38,
  },
  dadras: {
    name: "dadras",
    x: 1.1,
    y: 2.1,
    z: -2,
    dt: 0.006,
    a: 3,
    b: 2.7,
    c: 1.7,
    d: 2,
    e: 9,
  },
  dequan: {
    name: "dequan",
    x: -0.29,
    y: -0.29,
    z: -0.59,
    dt: 0.00028,
    a: 40.0,
    b: 1.833,
    c: 0.16,
    d: 0.65,
    e: 55.0,
    f: 20.0,
  },
  fourwing: {
    name: "fourwing",
    x: 0.5,
    y: 0.4,
    z: -0.5,
    dt: 0.06,
    a: 0.2,
    b: 0.01,
    c: -0.4,
  },
  halvorsen: {
    name: "halvorsen",
    x: -1.48,
    y: -1.51,
    z: 2.04,
    dt: 0.009,
    a: 1.89,
  },
  lorenz: {
    name: "lorenz",
    x: 0.1,
    y: 0,
    z: 0,
    dt: 0.002,
    a: 10,
    b: 28,
    c: 8 / 3,
  },
  lorenz83: {
    name: "lorenz83",
    x: -0.2,
    y: -2,
    z: -2.71,
    dt: 0.0027,
    a: 0.95,
    b: 7.91,
    c: 4.83,
    d: 4.66,
  },
  lorenzMod2: {
    name: "lorenzMod2",
    x: 0.5,
    y: 0.5,
    z: 0.5,
    dt: 0.0007,
    a: 0.9,
    b: 5.0,
    c: 9.9,
    d: 1.0,
  },
  rabin: {
    name: "rabin",
    x: 0.02,
    y: -0.3,
    z: 0.1,
    dt: 0.0175,
    a: 0.14,
    b: 0.1,
  },
  rossler: {
    name: "rossler",
    x: -0.2,
    y: -2,
    z: -2.71,
    dt: 0.0059,
    a: 0.2,
    b: 0.2,
    c: 5.7,
  },
  sprott: {
    name: "sprott",
    x: 0.63,
    y: 0.47,
    z: -0.54,
    dt: 0.01,
    a: 2.07,
    b: 1.79,
  },
  thomas: {
    name: "thomas",
    x: 0.8,
    y: 0.8,
    z: -0.1,
    dt: 0.06,
    b: 0.208186,
  },
  threeScroll1: {
    name: "threeScroll1",
    x: -0.29,
    y: -0.25,
    z: -0.59,
    dt: 0.0007,
    a: 40.0,
    b: 0.833,
    c: 20.0,
    d: 0.5,
    e: 0.65,
  },
  threeScroll2: {
    name: "threeScroll2",
    x: -0.29,
    y: -0.29,
    z: -0.59,
    dt: 0.0005,
    a: 32.48,
    b: 45.84,
    c: 1.18,
    d: 0.13,
    e: 0.57,
    f: 14.7,
  },
};
